<template>
    <div class="content">
        <!--        <div class="privilege-box" :class="{ 'special-background': customBackground }">-->
        <!--            <div class="privilege-item">-->
        <!--                <img class="privilege-item-img" src="https://cos.astrolinkwatch.com/bdwatch_official/home/11freeDelivery.png">-->
        <!--                <div class="privilege-item-title">FREE DELIVERY</div>-->
        <!--            </div>-->
        <!--            <div class="privilege-item">-->
        <!--                <img class="privilege-item-img" src="https://cos.astrolinkwatch.com/bdwatch_official/home/12returnPolicy.png">-->
        <!--                <div class="privilege-item-title">RETURN POLICY</div>-->
        <!--            </div>-->
        <!--            <div class="privilege-item">-->
        <!--                <img class="privilege-item-img" src="https://cos.astrolinkwatch.com/bdwatch_official/home/13qualityWarranty.png">-->
        <!--                <div class="privilege-item-title">QUALITY WARRANTY</div>-->
        <!--            </div>-->
        <!--            <div class="privilege-item">-->
        <!--                <img class="privilege-item-img" src="https://cos.astrolinkwatch.com/bdwatch_official/home/14payment.png">-->
        <!--                <div class="privilege-item-title">SECURE PAYMENT</div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="bottom-box">
            <div class="bottom-box-top">
                <div class="bottom-box-top-left">
                    <div class="menu-ul">
                        <div class="menu-ul-title" @click="toPage('watches')">WATCHES</div>
                        <div class="menu-li" @click="toPage('astrolinks')">ASTROLINK S</div>
                        <div class="menu-li" @click="toPage('astrolinkg')">ASTROLINK G</div>
                        <div class="menu-li" @click="toPage('astrolinku')">ASTROLINK U</div>
                    </div>
                    <div class="menu-ul" @click="toPage('support')">
                        <div class="menu-ul-title">SUPPORT</div>
                        <div class="menu-li">After Sales</div>
                        <div class="menu-li">FAQs</div>
                        <div class="menu-li">ASWEAR Global</div>
                    </div>
                    <div class="menu-ul" @click="toPage('brand')">
                        <div class="menu-ul-title">BRAND</div>
                        <div class="menu-li">About Us</div>
                        <div class="menu-li">History</div>
                    </div>
                    <div class="menu-ul" @click="toPage('partners')">
                        <div class="menu-ul-title">PARTNERS</div>
                        <div class="menu-li">Contact Us</div>
                        <div class="menu-li">Business Inquiries</div>
                    </div>
                </div>
                <div class="bottom-box-top-right">
                    <img class="qr-img" src="https://cos.astrolinkwatch.com/bdwatch_official/support/15qr.png">
                    <div class="qr-name">ASTROLINK APP</div>
                </div>
            </div>
            <div class="bottom-box-bottom">
                <div class="bottom-box-bottom-left">
                    <div class="bottom-box-bottom-left-text">© 2025 astrolinkwatch.com, Inc. All Rights Reserved.</div>
                    <div>Privacy & Security</div>
                    <div>Terms of Use</div>
                    <div>Corporate Site</div>
                </div>
                <div class="bottom-box-bottom-right">
                    <img src="https://cos.astrolinkwatch.com/bdwatch_official/home/15facebook.png" @click="toPage('facebook')">
                    <img src="https://cos.astrolinkwatch.com/bdwatch_official/home/16x.png" @click="toPage('x')">
                    <img src="https://cos.astrolinkwatch.com/bdwatch_official/home/17youtube.png" @click="toPage('youtube')">
                    <img src="https://cos.astrolinkwatch.com/bdwatch_official/home/18lk.png" @click="toPage('linkedIn')">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: {
        customBackground: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            toPage(page) {
                switch (page) {
                    case 'watches':
                        this.$router.push({name: 'watches'});
                        break;
                    case 'astrolinks':
                        this.$router.push({name: 'astrolinks'});
                        break;
                    case 'astrolinkg':
                        this.$router.push({name: 'astrolinkg'});
                        break;
                    case 'astrolinku':
                        this.$router.push({name: 'astrolinku'});
                        break;
                    case 'support':
                        this.$router.push({name: 'support'});
                        break;
                    case 'brand':
                        this.$router.push({name: 'brand'});
                        break;
                    case 'partners':
                        this.$router.push({name: 'partners'});
                        break;
                    case 'facebook':
                        window.open('https://www.facebook.com/profile.php?id=61562256397808');
                        break;
                    case 'x':
                        window.open('https://www.instagram.com/astrolinkwatch/');
                        break;
                    case 'youtube':
                        window.open('https://www.youtube.com/@ASTROLINKWATCH');
                        break;
                    case 'linkedIn':
                        window.open('https://www.linkedin.com/company/astrolinkwatch/');
                    default:
                        console.log('Page not found');
                }
            }
        }
    },
    mounted() {
    },
    methods: {}
}
</script>

<style scoped>

.content {
    width: 1920px;
    background-color: #000000;
}

.privilege-box {
    width: 1920px;
    height: 200px;
    background: #F2F3F5;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 99px;
}

.privilege-item {
    width: 300px;
    text-align: center;
}

.privilege-item-img {
    height: 46px;
    margin-bottom: 29px;
}

.privilege-item-title {
    font-size: 16px;
    font-family: PH-Regular;
    color: #777777;
    line-height: 16px;
}

.bottom-box {
    width: 1920px;
    height: 420px;
    padding-top: 99px;
}

.bottom-box-top {
    width: 1920px;
    height: 329px;
    display: flex;
    justify-content: space-between;
}

.bottom-box-top-left {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    margin-left: 120px;
}

.menu-ul {
    width: 300px;
    padding: 0 10px;
    cursor: pointer;
}

.menu-ul-title {
    font-size: 16px;
    color: #FFFFFF;
    font-family: PH-Regular;
    margin-bottom: 13px;
}

.menu-li {
    font-size: 16px;
    color: #777777;
    font-family: PH-Regular;
    line-height: 30px;
}

.menu-li:hover {
    color: #ffffff;
}

.bottom-box-top-right {
    text-align: center;
    margin-right: 123px;
}

.qr-img {
    width: 109px;
    height: 109px;
    border-radius: 4px;
    background-color: #ffffff;
    margin: 0 auto 12px;
}

.qr-name {
    font-size: 16px;
    color: #777777;
    font-family: PH-Regular;
}

.bottom-box-bottom {
    display: flex;
    justify-content: space-between;
}

.bottom-box-bottom-left {
    width: 1000px;
    display: flex;
    font-size: 12px;
    color: #FFFFFF;
    font-family: PH-Regular;
}

.bottom-box-bottom-left-text {
    margin-left: 120px;
    margin-right: 86px !important;
}

.bottom-box-bottom-left div {
    margin-right: 30px;
}

.bottom-box-bottom-right {
    margin-right: 120px;
}

.bottom-box-bottom-right img {
    height: 14px;
    margin: 0 5px;
    cursor: pointer;
}

.special-background {
    background: #111111; /* 特殊背景颜色 */
}
</style>


// WEBPACK FOOTER //
// src/layout/ContainerBottom/index.vue